import * as React from 'react'

function IconRectangleTime({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={98}
      height={144}
      viewBox="0 0 100 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter4_rectangle)">
            <path
              d="M82.601 143H15.4c0-7.94-6.45-14.381-14.399-14.381V15.381C8.95 15.381 15.399 8.94 15.399 1H82.6c0 7.94 6.45 14.381 14.399 14.381V128.62c-7.95 0-14.399 6.441-14.399 14.381z"
              fill="#fff"
            />
            <path
              d="M82.601 143H15.4c0-7.94-6.45-14.381-14.399-14.381V15.381C8.95 15.381 15.399 8.94 15.399 1H82.6c0 7.94 6.45 14.381 14.399 14.381V128.62c-7.95 0-14.399 6.441-14.399 14.381z"
              stroke="#A2A2A2"
              strokeWidth={2}
              strokeMiterlimit={10}
            />
            <path
              d="M22.84 133.841a23.786 23.786 0 00-12.504-12.489v-98.54a23.786 23.786 0 0012.503-12.489h52.515a23.786 23.786 0 0012.503 12.489v98.54a23.785 23.785 0 00-12.503 12.489H22.839z"
              fill="#A2A2A2"
            />
            <path
              d="M49.159 95.04C62.27 95.04 72.9 84.424 72.9 71.33c0-13.096-10.63-23.712-23.742-23.712-13.113 0-23.743 10.616-23.743 23.712 0 13.095 10.63 23.711 23.743 23.711z"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
            <path
              d="M49.159 58.528v9.276c0 2.257.895 4.425 2.497 6.024l5.439 5.432"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="filter4_rectangle"
              x={0}
              y={0}
              width={98}
              height={144}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M82.601 143H15.4c0-7.94-6.45-14.381-14.399-14.381V15.381C8.95 15.381 15.399 8.94 15.399 1H82.6c0 7.94 6.45 14.381 14.399 14.381V128.62c-7.95 0-14.399 6.441-14.399 14.381z"
            fill="#fff"
          />
          <path
            d="M82.601 143H15.4c0-7.94-6.45-14.381-14.399-14.381V15.381C8.95 15.381 15.399 8.94 15.399 1H82.6c0 7.94 6.45 14.381 14.399 14.381V128.62c-7.95 0-14.399 6.441-14.399 14.381z"
            stroke="#A2A2A2"
            strokeWidth={2}
            strokeMiterlimit={10}
          />
          <path
            d="M22.84 133.841a23.786 23.786 0 00-12.504-12.489v-98.54a23.786 23.786 0 0012.503-12.489h52.515a23.786 23.786 0 0012.503 12.489v98.54a23.785 23.785 0 00-12.503 12.489H22.839z"
            stroke="#A2A2A2"
            strokeWidth={0.75}
            strokeMiterlimit={10}
          />
          <path
            d="M49.159 95.04C62.272 95.04 72.9 84.424 72.9 71.33c0-13.096-10.63-23.712-23.742-23.712-13.113 0-23.743 10.616-23.743 23.712 0 13.095 10.63 23.711 23.743 23.711z"
            stroke="#A2A2A2"
            strokeWidth={5}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M49.159 58.528v9.276c0 2.257.895 4.425 2.497 6.024l5.439 5.432"
            stroke="#A2A2A2"
            strokeWidth={5}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconRectangleTime
